import React from 'react'
import { CheckCircleOutlined, ExclamationCircleOutlined, StopOutlined } from '@ant-design/icons'
import type { ComplianceAlert } from '../../types/compliance'
import { Badge, Tooltip } from 'antd'

const STATUS_CONFIG = {
  ok: { color: '#52c41a', Icon: CheckCircleOutlined, title: 'Срок действия в норме' },
  warning: {
    color: '#fa8c16',
    Icon: ExclamationCircleOutlined,
    title: 'Срок истекает в ближайшие 30 дней',
  },
  expired: { color: '#ff4d4f', Icon: StopOutlined, title: 'Срок истёк' },
  missing: { color: '#bfbfbf', Icon: ExclamationCircleOutlined, title: 'Дата не указана' },
} as const

export function ComplianceStatusIcon({ alert }: { alert: ComplianceAlert | null | undefined }) {
  if (!alert) return null
  const config = STATUS_CONFIG[alert]
  if (!config) return null
  const { color, Icon, title } = config
  return (
    <Tooltip title={title}>
      <Badge
        count={<Icon style={{ color, fontSize: 16 }} title={title} />}
        color={color}
        title={title}
      />
    </Tooltip>
  )
}
